export default "__VITE_ASSET__VaJY90uB__"